import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-multi-search-bar]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-multi-search-bar-mobile]').forEach((searchBarMobile) => {
    searchBarMobile.addEventListener('click', showMultiSearchBarMobile);
  });

  $$('[data-au-multi-search-bar-mobile-close]').forEach((searchBarMobile) => {
    searchBarMobile.addEventListener('click', hideMultiSearchBarMobile);
  });

  $$('[data-au-multi-search-clean-all]').forEach((el) => {
    el.addEventListener('click', multiSearchDatalayerOnCleanAllFilters);
  });

  $$('[data-au-multi-search-bar-submit]').forEach((el) => {
    el.addEventListener('click', multiSearchDatalayerOnSubmit);
  });

  $$('[data-au-multi-search-bar-main-inner]').forEach((el) => {
    multiSearchDatalayerOnLoad(el);
  });
}

function showMultiSearchBarMobile(e) {
  const multiSearchBarMain = e.target
    .closest('[data-au-multi-search-bar]')
    .querySelector('[data-au-multi-search-bar-main]');

  multiSearchBarMain.classList.add('au-multi-search-bar__main--visible');
  document.body.classList.add('au-overflow-hidden');
}

function hideMultiSearchBarMobile(e) {
  const multiSearchBarMain = e.target
    .closest('[data-au-multi-search-bar]')
    .querySelector('[data-au-multi-search-bar-main]');

  multiSearchBarMain.classList.remove('au-multi-search-bar__main--visible');
  document.body.classList.remove('au-overflow-hidden');
}

function multiSearchDatalayerOnCleanAllFilters(el) {
  // clear form fields
  const inputs = el.target.closest('[data-au-multi-search-bar]').querySelectorAll("input[type='text'], select");
  const selectOptions = el.target.closest('[data-au-multi-search-bar]').querySelectorAll('[data-au-listbox-option]');
  const selectText = el.target.closest('[data-au-multi-search-bar]').querySelectorAll('[data-au-select-text]');

  inputs.forEach((input) => {
    if (input.tagName === 'SELECT') {
      input.selectedIndex = 0;
    } else {
      input.value = '';
    }
  });

  selectOptions.forEach((option) => {
    option.classList.remove('au-active');
    option.setAttribute('aria-selected', 'false');
  });

  selectText.forEach((text) => {
    text.textContent = '';
  });

  // datalayer
  const titleText = el.target.closest('[data-au-chips-block]').querySelector('[data-au-chips-title]')
    ? el.target.closest('[data-au-chips-block]').querySelector('[data-au-chips-title]').innerText
    : '';
  const clickText = el.target.querySelector(':not([data-au-icon])').innerText;
  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

function multiSearchDatalayerOnSubmit(el) {
  const titleText = el.target.closest('[data-au-multi-search-bar]').querySelector('[data-au-chips-title]')
    ? el.target.closest('[data-au-multi-search-bar]').querySelector('[data-au-chips-title]').innerText
    : '';
  const clickText = el.target.querySelector(':not([data-au-icon])').innerText;
  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

function multiSearchDatalayerOnLoad(el) {
  const inputs = el.querySelectorAll("input[type='text'], select");
  const values = Array.from(inputs)
    .map((input) => input.value.trim())
    .filter((value) => value !== ''); // Remove empty values
  const item_id = removeAccentMarkAndUppercase(values.join('_'));

  if (item_id !== '') {
    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickBoton',
      item_id,
    });
  }
}

export default { init };
